import React, { useState, useEffect } from "react";
import "./App.scss";
import Routes from "./routes";
import CacheBuster from "./CacheBuster";
import VideoTutorial from "./components/VideoTutorial";
import { getShowVideoTutorial } from "./helper";
import { isMobile } from "react-device-detect";

export default function App() {
  const showTutorial = getShowVideoTutorial();
  const [firstTimeRender, setFirstTimeRender] = useState(false);
  const [showTutorialFromCache, setShowTutorialFromCache] = useState(
    showTutorial && !firstTimeRender
  );
  useEffect(() => {
    !firstTimeRender && setFirstTimeRender(true);
  }, [firstTimeRender, setFirstTimeRender]);
  return (
    <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
        if (loading) return null;
        !loading && !isLatestVersion && refreshCacheAndReload();
        return (
          <div className="App">
            <Routes isMobile={isMobile} />
            {showTutorialFromCache &&
              window.location.href.split("/")[3] !== "admin" && (
                <VideoTutorial
                  show={showTutorialFromCache}
                  setShow={(value) => setShowTutorialFromCache(value)}
                  isMobile={isMobile}
                />
              )}
          </div>
        );
      }}
    </CacheBuster>
  );
}
